<template>
    <VTableRow>
        <VTableHeadline v-bind:width="getColumnWidth(ResultsBlockType.Time, sportType)" />
        <VTableHeadline
            v-bind:colspan="columnCount - 1"
            align="left"
        >
            {{ leagueName }}
        </VTableHeadline>
    </VTableRow>
    <OutrightResult
        v-for="(outrights, index) in results"
        v-bind:key="outrights.id"
        v-bind:index="index"
        v-bind:result="outrights"
    />
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import type { PropType } from 'vue';
    import VTableHeadline from '@/components/common/table/VTableHeadline.vue';
    import VTableRow from '@/components/common/table/VTableRow.vue';
    import OutrightResult from '@/components/results/OutrightResult.vue';
    import { getColumnWidth } from '@/components/results/resultColumnHelper';
    import type { IOutrightResult } from '@/interface/IResult';
    import { ResultsBlockType } from '@/interface/enum';
    import { useResultsStore } from '@/store/resultsStore';

    const { sportType } = storeToRefs(useResultsStore());

    defineProps({
        results: {
            type: Object as PropType<IOutrightResult[]>,
            required: true,
        },
        leagueName: {
            type: String,
            required: true,
        },
        columnCount: {
            type: Number,
            required: true,
        },
    });
</script>
